module.exports = __webpack_public_path__ + "img/addReason.c8651b8d.png";